import { defineDSElements } from '@platform-ui/design-system-wc';

require('@webcomponents/custom-elements');
defineDSElements(window);
